import {UI} from "../../../stem-core/src/ui/UIBase";

import {Toast, ToastStyle} from "../../ui/Toast";
import {styleRule, styleRuleInherit} from "../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../stem-core/src/ui/style/Theme";
import {Dispatcher} from "../../../stem-core/src/base/Dispatcher";
import {Router} from "../../../stem-core/src/ui/Router";
import {
    BANNER_TIMEOUT,
    BANNER_TRANSITION_TIME,
    WALLET_EXPANDED_WIDTH,
    WIDGET_CARD_PADDING_TOP
} from "../WidgetConstants";
import {WidgetRoutes} from "../WidgetRoutes";


export class BannerStyle extends ToastStyle {
    transitionTime = BANNER_TRANSITION_TIME;

    @styleRule
    toast = {
        position: "absolute",
        padding: "15px 24px",
        zIndex: 3,
        color: this.themeProps.WHITE,
        fontSize: 13,
        transform: "translateY(calc(-100% - 6px))",
        transition: this.transitionTime / 1000 + "s ease",
        top: 0,
        width: WALLET_EXPANDED_WIDTH,
        overflow: "hidden",
        minWidth: "100%",
        boxShadow: this.themeProps.WALLET_BANNER_SHADOW,
    };

    @styleRule
    visible = {
        transform: "translateY(0)",
    };

    @styleRuleInherit
    action = {
        display: "inline-block",
        color: this.themeProps.WHITE,
        textDecoration: "underline",
        marginLeft: 5,
    }
}


// TODO @branch @cleanup fucking hell, another toast bullshit, merge with regular toast
@registerStyle(BannerStyle)
export class Banner extends Toast {
    static registeredPath = null;
    static onHideTimeout = null;

    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            visibleTimeout: BANNER_TIMEOUT,
            testId: "banner",
        };
    }

    static kill() {
        if (Toast.active) {
            Toast.active.remove();
            this.registeredPath = null;
            Dispatcher.Global.dispatch("widgetAnimationUpdateHeightDelta", 0);
        }
    }

    static show(...args) {
        clearTimeout(this.onHideTimeout); // the widget should maintain its height if another banner is displayed
        this.registeredPath = Router.localHistory.slice(-1)[0].slice(1);
        if (this.registeredPath === WidgetRoutes.INDEX_COLLAPSED) {
            this.registeredPath = null;
            return;
        }
        const banner = super.show(...args);
        if (banner) {
            Dispatcher.Global.dispatch("widgetAnimationUpdateHeightDelta", banner.getHeight() - WIDGET_CARD_PADDING_TOP / 2);
        }
    }

    static hide(...args) {
        this.registeredPath = null;
        super.hide(...args);
        // the widget gets to its initial height while the banner is hiding
        this.onHideTimeout = setTimeout(() => Dispatcher.Global.dispatch("widgetAnimationUpdateHeightDelta", 0), BANNER_TRANSITION_TIME / 2);
    }

    onMount() {
        super.onMount();

        this.attachListener(Dispatcher.Global, "killAllPopups", () => this.constructor.kill());
    }
}
